import React from 'react';
import './hero.scss';
import heroImg from '../../images/hi.png'
import supportImg from '../../images/support.svg'
import { Link } from 'react-router-dom';

const Hero = () => {
    return (
        <div className="hero">
            <div className="container">
                <div className="hero-flex">
                <div className="left">
                    <h2>Hola,</h2>
                        {/* <h2>Ariful Mowla</h2> */}
                        
                        <h1>Implement Your Dream In Web.</h1>
                    {/* <ul>
                        <li>Web Developer</li>
                        <li>Security expert</li>
                    </ul> */}
                    <p>
                        I am a self-taught full-stack web developer and security expert, Who loves coding and debag until fixing all errors. I help people to execute their plans in the digital platform and grow revenue. 
                    </p>
                        <Link to="/contact" className="btn btn-blank">
                            Get In Touch
                        </Link>
                    </div>
                    <div className="right">
                        <img src={supportImg} alt=""/>
                    </div>
            </div>
            </div>
        </div>
    );
};

export default Hero;